import React from 'react';
import ModuleRoute from 'holocron-module-route';
import checkTheUrlParams from './URLHooks';
import { loadProductsData } from './utils/loadProductsData';
// import callIfDevelopment from './callIfDevelopment';
import ErrorLayout from './components/ErrorLayout/ErrorLayout';

const childRoutes = (store) => [
  <ModuleRoute key="axp-maps-root" moduleName="axp-maps-root">
    <ModuleRoute onEnter={loadProductsData(store)}>
      <ModuleRoute path=":locale/maps/offers" title="Merchant Offers" moduleName="axp-one-maps-offers" onEnter={checkTheUrlParams(store)} />
      <ModuleRoute path=":locale/maps/online" title="Merchant Online Businesses" moduleName="axp-one-maps-online" onEnter={checkTheUrlParams(store)} />
      <ModuleRoute path=":locale/maps*" title="Merchant Maps" moduleName="axp-one-maps" onEnter={checkTheUrlParams(store)} />
      <ModuleRoute path="*" title="Merchant Maps" moduleName="axp-one-maps" onEnter={checkTheUrlParams(store)} />
    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute component={ErrorLayout} key="error-layout">
    <ModuleRoute
      code="500"
      key="load-error"
      moduleName="axp-error-message"
      path="*/error"
      title="Load Error"
      httpStatus={500}
    />
    <ModuleRoute
      code="400"
      key="not-found-error"
      moduleName="axp-error-message"
      path="*"
      title="Not Found"
      httpStatus={404}
    />
  </ModuleRoute>,
];

export default childRoutes;
